import { ButtonBase, Grid } from '@mui/material';
import { Fragment, memo, useMemo } from 'react';
import { useShowroom } from 'context';
import ShaxmatkaHomeTooltip from '../../../shaxmatka/shaxmatka-parts/tooltips/ShaxmatkaHomeTooltip';

export default memo(function Floor({
  homes,
  floorNumber,
  maxPlace,
  index,
  settingsMenuValue = 'square',
}) {
  const [, dispatch] = useShowroom();
  const homeList = useMemo(() => {
    const floorH = homes?.filter((home) => home?.stage == floorNumber);
    const homesN = new Array(maxPlace).fill(null);
    floorH.forEach((h, index) => {
      const place = h?.place ? h?.place - 1 : index;
      homesN[place] = h;
    });
    return homesN?.map((i) =>
      i
        ? i
        : {
            id: Date.now().toString(36) + Math.random().toString(36).substr(2), // STABIL ID
            isFree: true,
          },
    );
  }, [floorNumber, homes, maxPlace]);

  const onClick = (e, id) => {
    document
      ?.querySelector('.showroom-wrapper')
      ?.querySelectorAll('.item-selected')
      ?.forEach((el) => el?.classList?.remove('item-selected'));
    e?.target?.classList?.toggle('item-selected');
    dispatch({ type: 'setHomeId', payload: id });
  };
  return (
    <Fragment>
      <Grid
        container
        rowSpacing={0}
        columns={{
          xs: parseInt(maxPlace),
          sm: parseInt(maxPlace),
        }}
        className={'sheet-home-row'}
      >
        {index == 0 && (
          <Grid
            item={true}
            sm={1}
            xs={1}
            className='sheet-home-cell !-ml-2.5 !mr-0'
          >
            <ButtonBase
              className='sheet-home-row-floor h-full w-8 text-sm font-medium !cursor-default'
              disableRipple
            >
              {floorNumber}
            </ButtonBase>
          </Grid>
        )}
        {homeList?.length > 0
          ? homeList.map((item) => (
              <Grid
                item={true}
                sm={1}
                xs={1}
                key={`block-${index}-home-${item.id}`}
                id={`block-${index}-home-${item.id}`}
                className={`sheet-home-cell relative !max-w-[30px] floor-${floorNumber} `}
              >
                {item?.contract?.is_notarial == 1 ? (
                  <div className='absolute -top-1 -right-1 w-3 h-3 rounded bg-[#FFD700] shadow-md z-10 pointer-events-none' />
                ) : (
                  ''
                )}
                {item?.isFree ? (
                  <ButtonBase
                    className={`block-${index}-home !border !border-dashed !border-cyan-500 home-item status-null`}
                  />
                ) : (
                  <ShaxmatkaHomeTooltip home={item}>
                    <ButtonBase
                      className={`block-${index}-home home-item status-${
                        item?.contract?.status == 2
                          ? 'completed'
                          : item?.status == 3 &&
                              item?.contract?.is_complete == 1
                            ? 'half-completed'
                            : item?.status == 2 &&
                                item?.order?.total_payments > 0
                              ? 'half-ordered'
                              : item?.status
                      }${item.disabled ? ' is-disabled' : ''}`}
                      id={`home-${item.id}`}
                      onClick={(e) => onClick(e, item?.id)}
                    >
                      {settingsMenuValue == 'rooms' ? (
                        !(item.stage && parseInt(item.stage) < 0) ? (
                          item.rooms ? (
                            <div className='pointer-events-none'>
                              {item.rooms}x
                            </div>
                          ) : (
                            ''
                          )
                        ) : (
                          <div className='pointer-events-none'>P</div>
                        )
                      ) : (
                        <div className='pointer-events-none'>{item.number}</div>
                      )}
                    </ButtonBase>
                  </ShaxmatkaHomeTooltip>
                )}
              </Grid>
            ))
          : [1].map((item) => (
              <Grid
                item={true}
                sm={1}
                xs={1}
                key={`block-home-empty-${item}`}
                id={`block-home-empty-${item}`}
                className={`sheet-home-cell sheet-home-empty-cell floor-${floorNumber}`}
              >
                <ButtonBase className='home-item is-empty'>
                  <div className='home-item-data'></div>
                </ButtonBase>
              </Grid>
            ))}
      </Grid>
    </Fragment>
  );
});
